<template>
  <div class="v2-container-small programmirovanie-why">
    <h2 class="title-secondary">
      Почему мы
    </h2>

    <div class="programmirovanie-why__items">
      <div
        v-for="(item, index) in items"
        :key="index"
        :class="['programmirovanie-why__item', { active: activeItemIdx === index }]"
      >
        <h5
          :style="{ color: item.color }"
          v-html="item.title"
        />
        <img
          :src="`/v2/catalog/programmirovanie/why/${index + 1}.svg`"
          :alt="index + 1"
          class="programmirovanie-why__item_number"
        >
        <img
          :src="`/v2/catalog/programmirovanie/why/plus.svg`"
          alt="+"
          class="programmirovanie-why__item_plus laptop"
          @click="activeItemIdx = index"
        >

        <p
          @click="activeItemIdx = null"
          v-html="item.text"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgrammirovanieWhy',
  data: () => ({
    activeItemIdx: null,
    items: [
      {
        color: '#4A88DA',
        title: 'Практика — <br> 80% занятия',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Все&nbsp;занятия&nbsp;— не&nbsp;просто теория и&nbsp;видео, а&nbsp;конкретные практические занятия, в&nbsp;результате прохождения уроков у&nbsp;ученика будет готовы сайт, игра,&nbsp;и&nbsp;т.д.',
      },
      {
        color: '#FB5018',
        title: 'Просто, понятно и&nbsp;весело',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Если&nbsp;ребенок устал от скучных занятий или не может усидеть на месте, — ему&nbsp;точно у&nbsp;нас понравится! Научим основам Python и&nbsp;C++ с&nbsp;юмором и&nbsp;игровыми методиками.',
      },
      {
        color: '#846EFB',
        title: 'Опытные преподаватели',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Все&nbsp;преподаватели&nbsp;— это эксперты в&nbsp;своей сфере. Они&nbsp;умеют найти подход к&nbsp;детям и&nbsp;объяснить даже сложный материал легко и&nbsp;увлекательно, а&nbsp;также всегда ответят на&nbsp;любые вопросы и&nbsp;помогут с&nbsp;домашками.',
      },
      {
        color: '#22AE73',
        title: 'Только актуальные навыки',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'В&nbsp;быстро меняющемся мире необходимо не&nbsp;отставать от&nbsp;потребностей общества, поэтому важно дать возможность ребенку развивать цифровые навыки с&nbsp;раннего возраста.',
      },
      {
        color: '#846EFB',
        title: 'Удобная <br> платформа',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Подключайтесь к&nbsp;занятиям с&nbsp;любого устройства. Если&nbsp;вы&nbsp;вдруг пропустили вебинар — не страшно: у&nbsp;вас&nbsp;будет видеозапись. Также на платформе есть домашние задания и&nbsp;чат&nbsp;для&nbsp;связи с&nbsp;куратором.',
      },
      {
        color: '#22AE73',
        title: 'Дружное <br> комьюнити',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'У&nbsp;всех наших учеников есть чат, где&nbsp;можно не&nbsp;только общаться друг с&nbsp;другом, но&nbsp;и&nbsp;помогать <br> с&nbsp;домашками, делиться впечатлениями и&nbsp;даже придумывать крутые совместные проекты!',
      },
      {
        color: '#FB5018',
        title: 'Общее развитие',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Занятия и практические задания развивают у детей фантазию и креативность, умение мыслить как нестандартно, так и логически. Эти навыки облегчат обучение в школе и помогут достигать поставленных целей в жизни.',
      },
    ],
  }),
};
</script>

<style scoped lang="scss">

.programmirovanie-why {
  h2 {
    margin-bottom: 60px;
    letter-spacing: -0.03em;

    @include media-down(tablet) {
      margin-bottom: 32px ;
    }
  }

  &__items {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;

    &::-webkit-scrollbar {
      width: 0;
    }

    @include media-down(laptop) {
      width: calc(100% + 16px);
      padding: 0 8px 16px;
      margin-left: -8px;
      margin-bottom: -16px;
      justify-content: flex-start;
      flex-wrap: nowrap;
      overflow-x: auto;
      gap: 12px;
    }
  }

  &__item {
    width: 295px;
    height: 260px;
    padding: 20px 20px 0;

    flex-shrink: 0;
    display: flex;
    flex-direction: column;

    filter: drop-shadow(4px 4px 20px rgba(7, 21, 57, 0.05));
    background-image: url("/v2/catalog/programmirovanie/why/bg.svg");
    border-radius: 20px;
    overflow: hidden;

    @include media-up(laptop) {
      &:hover {
        p {
          opacity: 1;
        }

        h5,
        .programmirovanie-why__item_number {
          opacity: 0;
        }
      }
    }

    @include media-down(laptop) {
      &.active {
        p {
          opacity: 1;
        }

        h5,
        .programmirovanie-why__item_number,
        .programmirovanie-why__item_plus {
          opacity: 0;
        }
      }
    }

    @include media-down(tablet) {
      padding: 20px 8px 0;
      width: 310px;
      background-image: url("/v2/catalog/programmirovanie/why/bg-mob.svg");
    }

    h5 {
      max-width: 230px;
      font-weight: 700;
      font-size: 28px;
      line-height: 90%;
      letter-spacing: -0.02em;
      transition: 200ms;
    }

    .programmirovanie-why__item_number {
      margin-top: auto;
      margin-left: auto;
      margin-right: -20px;
      transition: 200ms;

      @include media-down(tablet) {
        margin-right: -8px;
      }
    }

    p {
      opacity: 0;
      position: absolute;
      inset: 0;
      padding: 24px;
      transition: 200ms;

      font-weight: 500;
      font-size: 18px;
      line-height: 130%;
      letter-spacing: -0.01em;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: rgba($black, 0.5);

      @include media-down(tablet) {
        padding: 20px 16px;
      }
    }

    .programmirovanie-why__item_plus {
      position: absolute;
      z-index: 2;
      width: 40px;
      height: 40px;
      top: 25px;
      right: 32px;
    }

    &:nth-of-type(1) .programmirovanie-why__item_plus {
      filter: invert(57%) sepia(8%) saturate(4449%) hue-rotate(179deg) brightness(89%) contrast(92%);
    }

    &:nth-of-type(2) .programmirovanie-why__item_plus {
      filter: invert(41%) sepia(84%) saturate(3616%) hue-rotate(352deg) brightness(101%) contrast(97%);
    }

    &:nth-of-type(3) .programmirovanie-why__item_plus {
      filter: invert(52%) sepia(37%) saturate(6355%) hue-rotate(225deg) brightness(99%) contrast(98%);
    }

    &:nth-of-type(4) .programmirovanie-why__item_plus {
      filter: invert(54%) sepia(64%) saturate(495%) hue-rotate(103deg) brightness(90%) contrast(89%);
    }

    &:nth-of-type(5) .programmirovanie-why__item_plus {
      filter: invert(45%) sepia(10%) saturate(7496%) hue-rotate(222deg) brightness(101%) contrast(97%);
    }

    &:nth-of-type(6) .programmirovanie-why__item_plus {
      filter: invert(60%) sepia(11%) saturate(3426%) hue-rotate(106deg) brightness(90%) contrast(73%);
    }

    &:nth-of-type(7) .programmirovanie-why__item_plus {
      filter: invert(37%) sepia(87%) saturate(2837%) hue-rotate(352deg) brightness(101%) contrast(97%);
    }
  }
}

</style>
